import { CanActivateFn, Router } from "@angular/router";
import { BreakpointService } from "../services/breakpoint.service";
import { inject } from "@angular/core";

export function desktopGuard(): CanActivateFn {
    return () => {
      const breakpointService: BreakpointService = inject(BreakpointService);
      const routerService: Router = inject(Router);
      
      if (breakpointService.isDesktop) {

        return true;
      }

      routerService.navigate(['/m/']);
      return false;
    };
  }